import { Component, OnInit, HostListener, AfterContentChecked } from '@angular/core';
import { EventEmitterService } from 'app/util/emitter-service/emitter-service';
import { EVENT_MSGS_UPDATE } from 'app/util/emitter-service/nome-evento';
import { bObservableUsuario, ObservableBlockPanel, ObservableBlockPanelDoc, ObservableLotacao } from 'app/util/observable-util';

import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ConfirmationService, TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { concat } from 'rxjs/observable/concat';
import { Sistema } from '../../sistema.model';
import { AutenticacaoService } from 'app/service/autenticacao.service';
import { NgProgress } from 'ngx-progressbar';
import { Locale } from 'app/util/locale.ptbr';
import { Helpers } from 'app/util/helpers';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'modulos-crud',
  templateUrl: 'modulos-crud.component.html',
  styleUrls: ['./modulos-crud.component.scss']
})
export class ModulosComponent extends BaseCrudComponent {

  contentCheck: number = 0;
  blockedPanel: boolean = true;
  sistemas: Array<any> = [];
  msgs: Message[] = [];
  count: number = 0;


  constructor(
    formBuilder: FormBuilder,
    ngProgress: NgProgress,
    router: Router,
    activatedRoute: ActivatedRoute,
    service: PadraoService,
    confirmacao: ConfirmationService,
    locale: Locale,
    help: Helpers,
    observableUtilPanel: ObservableBlockPanel,
    observableUtilPanelDoc: ObservableBlockPanelDoc,
    observableUtilLotacao: ObservableLotacao,
    observableUser: bObservableUsuario,
    currencyPipe: CurrencyPipe,
    public autenticacaoService: AutenticacaoService
  ) {
    super(formBuilder, ngProgress, router, activatedRoute, service, confirmacao, locale, help, observableUtilPanel, observableUtilPanelDoc,
      observableUtilLotacao, observableUser, currencyPipe)
  }


  ngOnInit() {
    // this.ngProgress.start();
    // this.ngProgress.done();

    if (localStorage.getItem("token") != null) {

      this.observableUser.getValue.subscribe(data => {
        if (data) {
          let usuario = data.obj
          let listaLotacao = usuario.lotacaoDTO
          let ids_sistemas: Array<number> = []
          listaLotacao[0].perfilDTO.forEach(perfil => {
            ids_sistemas.push(perfil.sistemaDTO.id)
          })
          ids_sistemas = ids_sistemas.filter((v, i) => ids_sistemas.findIndex(item => item == v) === i)
          ids_sistemas.forEach(sistemaid => {
            this.autenticacaoService.obterSistemas(sistemaid).subscribe(s => { this.sistemas.push(s) })
          })
        }
      })
    }

    if (sessionStorage.getItem("msg") !== null) {
      this.showMsg('success', 'Mensagem de Sucesso', sessionStorage.getItem("msg"))
    }
    sessionStorage.removeItem("msg");
  }

  ngAfterContentChecked() {
    if (this.contentCheck++ > 10)
      this.blockedPanel = false;
  }

  showMsg(severity: string, summary: string, detail: string) {
    this.msgs = [];
    this.msgs.push({ severity: severity, summary: summary, detail: detail });
    EventEmitterService.get(EVENT_MSGS_UPDATE).emit(this.msgs);
  }

  clickSistem(link: string) {
    window.location.href = link;
  }

}


// WEBPACK FOOTER //
// ./src/app/modulos/crud/modulos-crud.component.ts